// FIKAMI LLC — contact constants
export const FIKAMI = {
  whatsappNumber: "+52 55 2170 2541",
  whatsappRaw: "525521702541",
  email: "miguelfierro@fikamillc.com",
  brand: "FIKAMI",
  brandFull: "FIKAMI LLC",
};

export const waLink = (message = "") => {
  const encoded = encodeURIComponent(message);
  return `https://wa.me/${FIKAMI.whatsappRaw}${encoded ? `?text=${encoded}` : ""}`;
};

export const mailLink = (subject = "", body = "") => {
  const s = subject ? `?subject=${encodeURIComponent(subject)}` : "";
  const b = body ? `${s ? "&" : "?"}body=${encodeURIComponent(body)}` : "";
  return `mailto:${FIKAMI.email}${s}${b}`;
};
